import './Login.css';
import axios from 'axios';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useRef } from 'react';
import { Context } from '../../contexts/Context'
import { notify } from '../../toast';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '142414806924-j4lusvkm1noph36d69b9totgvrtdeoa1.apps.googleusercontent.com';
const GOOGLE_SCRIPT_ID = 'google-identity-services-script';

export default function Login({ setToken }) {
  const googleButtonRef = useRef(null);

  const context = useContext(Context)

  const setAuthToken = useCallback((responseData) => {
    const authToken = responseData.token || responseData.key || responseData.auth_token;

    if (!authToken) {
      notify.error('Login failed. The backend did not return a token.')
      return
    }

    setToken(authToken);
  }, [setToken])

  const handleGoogleLogin = useCallback((googleResponse) => {
    if (!googleResponse.credential) {
      notify.error('Google login failed. Please try again.')
      return
    }

    axios.post(context.API + 'auth/okiagent-social-auth-callback/', {
      id_token: googleResponse.credential
    })
    .then((response) => {
      setAuthToken(response.data);
    }, (error) => {
      notify.error('Google login failed. Please try again or contact the administrator.')
      console.log(error)
    });
  }, [context.API, setAuthToken])

  useEffect(() => {
    const initializeGoogleLogin = () => {
      if (!window.google || !googleButtonRef.current) return

      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: handleGoogleLogin
      });

      googleButtonRef.current.innerHTML = '';
      window.google.accounts.id.renderButton(
        googleButtonRef.current,
        {
          theme: 'outline',
          size: 'large',
          width: 320
        }
      );
    }

    if (window.google) {
      initializeGoogleLogin();
      return
    }

    const existingScript = document.getElementById(GOOGLE_SCRIPT_ID);
    if (existingScript) {
      existingScript.addEventListener('load', initializeGoogleLogin);
      return () => existingScript.removeEventListener('load', initializeGoogleLogin);
    }

    const script = document.createElement('script');
    script.id = GOOGLE_SCRIPT_ID;
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = initializeGoogleLogin;
    document.body.appendChild(script);
  }, [handleGoogleLogin])

    return (
        <div className="login-page">
          <main className="login-shell">
            <section className="login-brand-panel">
              <img className="login-logo" src="/logo_okify_white.png" alt="Okify" />
              <div>
                <h1>Oki-Core</h1>
                <p className="login-copy">Access your operations workspace with your company Google account.</p>
              </div>
            </section>

            <section className="login-card" aria-label="Sign in">
              <h2>Welcome back</h2>
              <p>Continue securely with Google.</p>
              <div ref={googleButtonRef} className="google-login-button"></div>
            </section>
          </main>
        </div>
    );
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired
};
